import {Pipe, PipeTransform} from '@angular/core';

/**
 * Conta o número de palavras de uma string.
 *
 * Uma "palavra" é qualquer sequência de caracteres não-whitespace separada
 * por um ou mais caracteres de espaço, tab ou quebra de linha.
 * Strings vazias ou nulas retornam `0`.
 *
 * @example
 * {{ 'Lorem ipsum dolor sit amet' | wordCount }}
 * // 5
 *
 * @example
 * {{ '' | wordCount }}
 * // 0
 */
@Pipe({name: 'wordCount', standalone: true})
export class WordCountPipe implements PipeTransform {
    transform(value: string | null | undefined): number {
        if (!value?.trim()) return 0;
        return value.trim().split(/\s+/).length;
    }
}

